export default {
  API_ENDPOINT:"https://portalbackend.phius.org/api",
  // API_ENDPOINT:"http://localhost:8000/api",
  TOKEN_KEY:"23480dfgsdg934fj3804fj304987trh3fh32094rhf"
}